<template>
  <div>
    <div v-if="pillsList.length" class="base-select-wrapper">
      <select class="base-select"
              v-model="selectedPlatform"
              @change="categoryChange">
        <option v-for="(select, index) in pillsList"
                :value="select.key"
                :key="index">
          {{ select.name }}
        </option>
      </select>
    </div>
    <plp-pills v-if="pillsList.length"
               :pillsList="pillsList"
               class="channel-pills"
               @click="handlePillClick"/>
  </div>
</template>

<script>
import PlpPills from '../plp/plp-pills'
import { platforms } from './platform-config'
import { customEvent } from '@/services/customEventBus'
import { getQueryParameters, setQueryParameters } from '../../utils/tvChannelsUrlFactory'

const compEvents = {
  platformSelected: 'platform-selected',
  pillsOffset: 'pillsOffset'
}

export default {
  name: 'channels-platform-select',
  components: { PlpPills },
  data () {
    return {
      pillsList: [...platforms],
      selectedPlatform: platforms.find(p => p.selected).key
    }
  },
  methods: {
    categoryChange (e) {
      this.selectPill(e.target.value)
      this.$emit(compEvents.platformSelected, e.target.value)
      setQueryParameters({ platform: e.target.value }, true)
    },
    handlePillClick (pillData) {
      this.selectPill(pillData.key)
      this.$emit(compEvents.platformSelected, pillData.key)
      this.$emit('change', pillData.key)
      setQueryParameters({ platform: pillData.key }, true)
    },
    selectPill (pillKey) {
      this.pillsList.forEach(pill => {
        const pillState = pill.key === pillKey
        this.$set(pill, 'selected', pillState)
      })

      this.selectedPlatform = pillKey
    },
    emitPillsOffset () {
      if (this.pillsList) {
        customEvent.$emit(compEvents.pillsOffset)
      }
    }
  },
  watch: {
    pillsList: {
      handler (newVal) {
        if (newVal && newVal.length) {
          const queryParams = getQueryParameters()
          if (queryParams.platform && platforms.some(platform => platform.key === queryParams.platform)) {
            this.$emit(compEvents.platformSelected, queryParams.platform)
            this.selectPill(queryParams.platform)
          } else {
            this.$emit(compEvents.platformSelected, this.selectedPlatform)
            setQueryParameters({ platform: this.selectedPlatform }, true)
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.base-select-wrapper {
  @media (map_get($breakpoints, md)) {
    display: none;
  }
}

.channel-pills {
  /deep/ &.sticky {
    left: 0 !important;
  }
}
</style>
